import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AttendanceMovement  {
    _originalTypeClassName = "zERP.BO.AttendanceMovement";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AttendanceMovement.translate = translateService;
}
this.Id = null;
this.DateTime = null;
this.MovementType = null;
this.IsActive = false;
this.CreatedAt = null;
this.LocationActive = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
DateTime:any;
MovementType:any;
IsActive:any;
CreatedAt:any;
LocationActive:any;
EmployeeContract:any;
CardID:any;
Location:any;
static setEmployeeContract = ($this, value) => {
var oldValue = $this.EmployeeContract;
$this.EmployeeContract = value;
if (value != null) {
}
}
static setCardID = ($this, value) => {
var oldValue = $this.CardID;
$this.CardID = value;
if (value != null) {
}
}
static setLocation = ($this, value) => {
var oldValue = $this.Location;
$this.Location = value;
if (value != null) {
}
}

static ParseMovementType(el: any): any{switch (el) {case "Είσοδος":
{
return Domain.MovementType.Entry;}
case "Έξοδος":
{
return Domain.MovementType.Exit;}
default:
{
return Domain.MovementType.Unknown;}
}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}